import { useUser } from '../../shared';
import { useCachedFetch } from '../../shared/hooks';
import apiRoutes from '../../../config/api/routes';
import { useCallback } from 'react';
import { IBookFeedback } from 'src/config/api/models/Feedback';

export const useStudentFeedback = () => {
  const { user, isStudent } = useUser();

  const studentFeedback = useCachedFetch<{data: IBookFeedback[]}>(
    ['studentFeedback', user.id],
    apiRoutes.getStudentFeedback(),
    {
      method: 'GET',
      options: {
        enabled: isStudent,
        cacheTime: 1000,
      },
    }
  );

  const refetch = useCallback(() => {
    if (isStudent) {
      studentFeedback.refetch().then();
    }
  }, [isStudent, studentFeedback]);

  return {
    feedback: studentFeedback?.data?.data,
    refetch,
  };
};
